<template>
	<Dialog titulo="Anotações" :subtitulo="patientName" btn_acao="Salvar" :btn_acao_disable="isSameNotes" :loading="loading"
		@close="close"
		@acao="updated_at ? updateNote() :
			insertNote()">
		<v-flex xs12 md12>
			<v-textarea v-model="annotation" label="Anotações da box" box hide-details :loading="loadingNotes"/>
			<h2 class="body-2 grey--text lighten-2--text mt-2">{{ textHint }}</h2>
		</v-flex>
	</Dialog>
</template>

<script>
import { AnotacaoPresenter } from '@Presenter/anotacao-presenter';
import $store from '@Store';
import { UserPresenter } from '@Presenter/user-presenter';

export default {
	name: 'DialogAnotacoes',
	props: {
		box_id: {
			type: Number,
			required: true
		},
		patientName: {
			type: String,
			default: ''
		}
	},
	data: () => ({
		loadingNotes: false,
		loading: false,
		annotation: '',
		oldNote: '',
		updated_at: '',
		user: {}
	}),
	created() {
		this.getNote();
	},
	methods: {
		getNote() {
			this.loadingNotes = true;
			AnotacaoPresenter.getNote(this.box_id)
				.then(item => {
					this.oldNote = item.anotacao;
					this.annotation = item.anotacao;
					this.updated_at = item.updated_at;
					this.getUserUpdated(item);
				})
				.catch(error => {
					if (error.__status === 404)
						$store.dispatch('SHOW_SNACKBAR', { visible: false });
					else {
						this.close();
						$store.dispatch('SHOW_SNACKBAR', { message: error.message, visible: true, color: 'error' });
					}
				})
				.finally(() => {
					this.loadingNotes = false;
				});
		},
		updateNote() {
			AnotacaoPresenter.updateNote(this.box_id, { anotacao: this.annotation, anotacao_antiga: this.oldNote })
				.then(() => {
					$store.dispatch('SHOW_SNACKBAR', { message: 'Anotação atualizada com sucesso', color: 'success' });
					this.close();
				}).finally(() => {
					this.loading = false;
				});
		},
		getUserUpdated(item) {
			UserPresenter.index()
				.then(users => {
					this.user = users.find(user => user.id === item.user_id);
				})
				.catch(() => {
					$store.dispatch('SHOW_SNACKBAR', { message: 'Erro ao procurar usuário', color: 'error' });
				});
		},
		insertNote() {
			this.loading = true;
			AnotacaoPresenter.insertNote(this.box_id, this.annotation)
				.then(() => {
					$store.dispatch('SHOW_SNACKBAR', { message: 'Anotação salva com sucesso', color: 'success' });
					this.close();
				})
				.finally(() => {
					this.loading = false;
				});
		},
		close() {
			this.$emit('close');
		}
	},
	computed: {
		isSameNotes() {
			// eslint-disable-next-line eqeqeq
			return this.oldNote == this.annotation;
		},
		textHint() {
			if (this.user && this.updated_at)
				return `Atualizado por ${this.user.nome} em ${this.updated_at}`;
			return '';
		}
	}
};
</script>
